import AtomicDNS from "../../../../src/courses/partials/atomic/dns.mdx";
import * as React from 'react';
export default {
  AtomicDNS,
  React
};